var app = angular.module("leonardo");

var CountryFormController = function($scope, $state, formObj, CountryService, FormErrorsService) {

  $scope.data = formObj;

  $scope.countryService = CountryService;

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = angular.copy($scope.data);
    if ($state.current.action === 'edit'){
      $scope.data.patch(data).then(function(){
        $state.go('countries.list');
      });
    }
    else {
      CountryService.post(data).then(function(result) {
        CountryService.updateCollection(result);
        $state.go('countries.list');
      });
    }
  };
};

app.controller('CountryFormController', ['$scope', '$state', 'formObj', 'CountryService', 'FormErrorsService',
  CountryFormController]);
